(function() {
    'use strict';

    var ConfirmationMailCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, passedModel, xmsNotificationFactory) {

        console.log("Inside ConfirmationMailCtrl");

        if( !angular.isDefined(passedModel) ){
            passedModel = {}; // otherwise any ng-init inside modal will create the model in it's own child scope (inaccessible)
        }
        $scope.confirmationModel = passedModel;
        $scope.pageModel = {};

        $scope.fnSendConfirmationMail = function($event, controllerName) {
            $event.preventDefault();

            var ajaxUrl = WEBAPP_PATH + "/" +controllerName+"/submitConfirmationForm?";

            ajaxCall.getData(ajaxUrl, $scope.confirmationModel, true).then(
                function(result) {
                    xmsNotificationFactory.addObj({id: "confirmationMailPop", type: result.data.responseType, bodyHtml: result.data.responseMessage, timeout:10});
                    $uibModalInstance.close($scope.confirmationModel);
                },
                function(result) {
                    var alertMessage = "Error occurred. Please try again later..";
                    xmsNotificationFactory.addObj({id: "confirmationMailPop", type: "danger", bodyHtml: alertMessage, timeout:10});
                    $uibModalInstance.close($scope.confirmationModel);
                }
            );
        }

        $scope.cancel = function(e) {
            if(angular.isDefined(e)){
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        };

    }
    ConfirmationMailCtrl.$inject = ['$scope', '$compile', '$uibModalInstance','ajaxCall','params','xmsNotificationFactory'];
    angular.module('app').controller('ConfirmationMailCtrl', ConfirmationMailCtrl);

}());